module.exports = __webpack_public_path__ + "img/step7.0de03b5f.png";